import React from 'react';
import styled, { withTheme } from 'styled-components';
import SearchBar from './SearchBar';
import SearchBarMobile from './SearchBarMobile';
import { MaxWidthLayoutDesktop } from '../../../templates/MaxWidthLayout';
import FullLayout from '../../../templates/FullLayout';
import MobileOpenIconSvg from '../../../svgs/MobileOpenIconSvg';
import MobileCloseIconSvg from '../../../svgs/MobileCloseIconSvg';
import MediaQueryHelper from '../../../templates/MediaQueryHelper';
import ShopsLogoContainer from '../shared/ShopsLogoContainer';
import theme from '@ui/theme';

const cssUtilFlexCenter = `
  display: flex;
  justify-content: center;
  align-items: center;
`;

const NavigationSearchBarDesktopDiv = styled.div`
  height: 72px;
  background-color: ${({ theme }) => theme.c.bg.primary};
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

const MobileNavigationDiv = styled.div`
  height: ${({ theme }) => theme.custom.HEADER_HEIGHT_MOBILE}px;
`;

const MobileStickyNavigvationDiv = styled.div`
  position: fixed;
  width: 100%;
  z-index: 100;
`;

const NavigationSearchBarMobileDiv = styled.div`
  z-index: 9;
  height: 57px;
  background-color: ${props => props.theme.c.bg.secondary};
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 1px 0 0 ${props => props.theme.c.border['box-shadow']};
`;

const LogoSection = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 6px 0;
  margin: 0 0 0 6px;
`;

const MenuButton = styled.button`
  background: transparent;
  border: none;
  ${cssUtilFlexCenter}
  padding: 4px 4px;
  margin: 0 6px 0 0;
  cursor: pointer;
`;

const ToggleMobileMenuButton = (props) => {
  const { isMobileMenuOpen, mobileMenuHandler = {}, menuToggleOpen, menuToggleClose } = props;

  return (
    <MenuButton
      onClick={mobileMenuHandler}
      aria-label={isMobileMenuOpen ? menuToggleClose : menuToggleOpen}
      aria-haspopup="true"
      aria-expanded={isMobileMenuOpen}>
      { isMobileMenuOpen ? (
        <MobileCloseIconSvg title={menuToggleClose} fill={theme.c.icon.interactive} />
      ) : (
        <MobileOpenIconSvg title={menuToggleOpen} fill={theme.c.icon.interactive} />
      )}
    </MenuButton>
  );
};

const NavigationSearchBar = withTheme((props) => {
  const {
    searchBarPlaceholderText,
    searchStoreTitle,
    searchCategoriesTitle,
    searchCtaButtonText,
    theme,
    locale,
    isMobileMenuOpen,
    pageStateModifiers,
    searchIconLabel,
    clearSearchLabel,
    menuToggleOpen,
    menuToggleClose,
    mobileMenuHandler = {},
    airmilesLogoNavSlot,
    shopsLogoNavSlot,
  } = props;

  const cssSearchBarDesktopBgColor = `background-color: ${theme.c.bg.primary}; border-bottom: 1px solid ${theme.c.border.primary}`;
  const DesktopBody = () => (
    <FullLayout outerStyles={cssSearchBarDesktopBgColor}>
      <MaxWidthLayoutDesktop>
        <NavigationSearchBarDesktopDiv>
          <LogoSection>
            <ShopsLogoContainer
              shopsLogoNavSlot={shopsLogoNavSlot}
              location="page:header"
              locale={locale}
            />
          </LogoSection>
          <SearchBar
            locale={locale}
            placeholder={searchBarPlaceholderText}
            searchStoreTitle={searchStoreTitle}
            searchCategoriesTitle={searchCategoriesTitle}
            searchCtaButtonText={searchCtaButtonText}
            pageStateModifiers={pageStateModifiers}
            searchIconLabel={searchIconLabel} />
        </NavigationSearchBarDesktopDiv>
      </MaxWidthLayoutDesktop>
    </FullLayout>
  );

  const MobileBody = () => (
      <MobileNavigationDiv>
        <MobileStickyNavigvationDiv>
          <NavigationSearchBarMobileDiv>
            <LogoSection>
              <ShopsLogoContainer
                shopsLogoNavSlot={shopsLogoNavSlot}
                location="page:header"
                locale={locale}
              />
            </LogoSection>
            <ToggleMobileMenuButton
              isMobileMenuOpen={isMobileMenuOpen}
              mobileMenuHandler={mobileMenuHandler}
              menuToggleOpen={menuToggleOpen}
              menuToggleClose={menuToggleClose}
            />
          </NavigationSearchBarMobileDiv>
          <SearchBarMobile
            locale={locale}
            placeholder={searchBarPlaceholderText}
            searchStoreTitle={searchStoreTitle}
            searchCategoriesTitle={searchCategoriesTitle}
            searchCtaButtonText={searchCtaButtonText}
            pageStateModifiers={pageStateModifiers}
            searchIconLabel={searchIconLabel}
            clearSearchLabel={clearSearchLabel} />
        </MobileStickyNavigvationDiv>
      </MobileNavigationDiv>
  );

  const renderComp = (
    <MediaQueryHelper
      desktopChildren={DesktopBody()}
      mobileChildren={MobileBody()} />);
  return renderComp;
});

export default NavigationSearchBar;
